import is from '@sindresorhus/is';

import type { UrlTileDefinition, UrlTileDefinitionInput, UrlTilePayload } from './types';

export const splitUrlTileValue = (value: string): readonly string[] => value.split('.');

export const createUrlTileDefinition = <TPayload extends UrlTilePayload, TProps>(
    input: UrlTileDefinitionInput<TPayload, TProps>,
): UrlTileDefinition => {
    const parsePayload = (payload: UrlTilePayload): TPayload | undefined => {
        const parsed = input.schema.safeParse(payload);

        return parsed.success ? parsed.data : undefined;
    };

    return {
        maxWidth: input.maxWidth,
        minWidth: input.minWidth,
        parseValue: (value) => {
            const parsed = input.schema.safeParse(input.parseTokens(splitUrlTileValue(value)));

            return parsed.success ? parsed.data : undefined;
        },
        renderPayload: (payload, context) => {
            const parsedPayload = parsePayload(payload);

            if (is.undefined(parsedPayload)) {
                return undefined;
            }

            return input.render(input.toProps(parsedPayload, context));
        },
        serializePayload: (payload) => {
            const parsedPayload = parsePayload(payload);

            return is.undefined(parsedPayload) ? undefined : input.serialize(parsedPayload);
        },
        slotKeyForPayload: (payload) => {
            const parsedPayload = parsePayload(payload);

            return is.undefined(parsedPayload) ? undefined : input.slotKey(parsedPayload);
        },
        tileKeyForPayload: (payload) => {
            const parsedPayload = parsePayload(payload);

            return is.undefined(parsedPayload) ? undefined : input.tileKey(parsedPayload);
        },
        type: input.type,
        width: input.width,
    };
};
